import React, { memo, useCallback, useState } from 'react'

import {
  Adjustments,
  Button,
  ClosingDropdown,
  Icon,
  classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import { DEFAULT_SETTINGS } from './Components/SettingsPanel/settingsOptions'
import SettingsPanel from './Components/SettingsPanel/SettingsPanel'

const settingsIcon = <Icon svgComponent={Adjustments} size={iconSize} notSpace color="darker" />

function GenerationSettings() {
  const t = useTranslation()
  const [settings, setSettings] = useState(DEFAULT_SETTINGS)
  const [isOpen, setIsOpen] = useState(false)

  const handleChange = useCallback((key, value) => {
    setSettings(current => ({ ...current, [key]: value }))
  }, [])

  // Not portalled: usePanelDismiss closes the assistant on any pointerdown outside
  // the panel's DOM, so a popover in <body> would close the panel on first touch.
  return (
    <ClosingDropdown
      content={<SettingsPanel settings={settings} onChange={handleChange} />}
      isSimpleContent
      size="medium"
      placement="top"
      contentClassName="generation-settings__popover"
      className="generation-settings"
      onOpenChange={setIsOpen}
    >
      <Button
        type="secondary"
        variant="only-icon"
        size="small"
        actionType="button"
        icon={settingsIcon}
        customClass={classnames(
          'generation-settings__trigger',
          isOpen && 'generation-settings__trigger--open',
        )}
        aria-label={t('imageAssistantPanel.createTab.composer.settings.trigger')}
        aria-haspopup="dialog"
        aria-expanded={isOpen}
      />
    </ClosingDropdown>
  )
}

export default memo(GenerationSettings)
